/*
 * "Complete your setup" add-on upsell + 2-pack card behaviour.
 *
 * Add-on rows each have a "+ Add" button that adds that accessory straight to
 * the cart and opens the drawer. The 2-pack card's button adds the configured
 * case and sends the shopper to the cases collection.
 *
 * Document-level event delegation so it survives the product section being
 * re-rendered via the Section Rendering API (inline scripts wouldn't).
 */
(function () {
  function cartRoot() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  }

  function openCartDrawer() {
    var openers = document.querySelectorAll('[data-sidebar-id="CartDrawer"]');
    var opened = false;
    openers.forEach(function (o) {
      if (!opened && o.offsetParent !== null) { o.click(); opened = true; }
    });
    if (!opened && openers[0]) openers[0].click();
  }

  function refreshDrawer(sectionId, sections) {
    if (!sectionId || !sections || !sections[sectionId]) return;
    var wrap = document.getElementById('shopify-section-' + sectionId);
    if (!wrap) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = sections[sectionId];
    var inner = tmp.querySelector('#shopify-section-' + sectionId);
    wrap.innerHTML = inner ? inner.innerHTML : sections[sectionId];
  }

  // Build the case line item from the product form (keeps variant, quantity,
  // line-item properties and selling plan so personalised products still work).
  function caseLineItem(form) {
    var fd = new FormData(form);
    var item = {id: fd.get('id'), quantity: Number(fd.get('quantity') || 1)};
    var props = {};
    fd.forEach(function (value, key) {
      var m = key.match(/^properties\[(.+)\]$/);
      if (m) props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    var sellingPlan = fd.get('selling_plan');
    if (sellingPlan) item.selling_plan = sellingPlan;
    return item;
  }

  function addToCart(items) {
    var root = cartRoot();
    var drawer = document.querySelector('cart-drawer');
    var sectionId = drawer ? drawer.getAttribute('data-section-id') : null;
    var body = {items: items};
    if (sectionId) { body.sections = sectionId; body.sections_url = window.location.pathname; }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json().then(function (data) { return {ok: r.ok, data: data}; }); })
      .then(function (res) {
        if (!res.ok || (res.data && res.data.status)) {
          throw new Error((res.data && res.data.description) || 'add failed');
        }
        refreshDrawer(sectionId, res.data.sections);
        openCartDrawer();
        document.dispatchEvent(new CustomEvent('cart:refresh', {bubbles: true}));
      });
  }

  // Add-on "+ Add" — add this accessory to the cart.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-fbt-add-item]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var id = btn.getAttribute('value');
    if (!id) return;

    var label = btn.querySelector('[data-fbt-add-label]');
    var original = label ? label.innerHTML : null;
    btn.disabled = true;

    var qty = parseInt(btn.getAttribute('data-fbt-qty'), 10) || 1;   // the pair offer sets 2
    addToCart([{id: id, quantity: qty}])
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = '✓ Added';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label && original !== null) label.innerHTML = original;
          btn.disabled = false;
        }, 1600);
      })
      .catch(function () {
        if (label && original !== null) label.innerHTML = original;
        btn.disabled = false;
      });
  });

  // ---- Tiered offer selector above Add-To-Cart -------------------------------
  // The shopper picks 1 case / case+accessory / 2 cases BEFORE buying, then the
  // theme's own Add-To-Cart is intercepted in the CAPTURE phase so we run before
  // <product-form>'s submit handler. "1 case" is the default and falls straight
  // through to the theme (EU law: never pre-select a paid add-on).
  function selectedOffer() {
    var el = document.querySelector('[data-bundle-offers] input[name="bundle_offer"]:checked');
    return el || null;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;

    // one add at a time: while the previous add is in flight, further taps
    // must not reach the theme either (that is how a slow network turned one
    // bundle into eight)
    if (form.__fbtBusy) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    var opt = selectedOffer();
    if (!opt) return;
    var mode = opt.getAttribute('data-offer-mode');
    if (!mode || mode === 'single') return;   // let the theme do its thing

    var ci = caseLineItem(form);
    if (!ci || !ci.id) return;

    var items = [ci];
    if (mode === 'kit') {
      var addonId = opt.getAttribute('data-offer-addon');
      if (!addonId) return;
      items.push({id: addonId, quantity: 1});
    } else if (mode === 'two') {
      ci.quantity = (Number(ci.quantity) || 1) + 1;   // same design x2
    } else {
      return;
    }

    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('button[name="add"]');
    form.__fbtBusy = true;
    // the theme's own spinner class is "loading"; disabled stops repeat taps
    if (btn) { btn.classList.add('loading'); btn.classList.add('is-loading'); btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    function release() {
      form.__fbtBusy = false;
      if (btn) { btn.classList.remove('loading'); btn.classList.remove('is-loading'); btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
    addToCart(items)
      .then(function () { release(); })
      .catch(function () {
        release();
        form.submit();   // fall back to the normal flow
      });
  }, true);

  // Keep the offer prices in sync with the selected variant (Snap / Tough /
  // MagSafe have different prices). All strings are pre-rendered by Liquid.
  //
  // The theme has no variant-change event -- it just mutates the hidden
  // input[name=id] asynchronously (and may re-render the block), so a single
  // delayed read races it and leaves the price stale until the next click.
  // Three overlapping signals instead: a burst after any interaction, a
  // MutationObserver on the input, and a cheap cached poll as a backstop.
  var lastVariantId = null;
  var lastBox = null;

  function syncOfferPrices(force) {
    var box = document.querySelector('[data-bundle-offers]');
    if (!box) { lastBox = null; return; }
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!idInput) return;
    var vid = String(idInput.value || '');
    if (!force && vid === lastVariantId && box === lastBox) return;   // nothing to do
    lastVariantId = vid;
    lastBox = box;
    var data;
    try { data = JSON.parse(box.getAttribute('data-offer-prices') || '{}'); } catch (err) { return; }

    // Shape is {sets: {...}, map: {variantId: setKey}} -- the price sets are
    // deduplicated, because this attribute is re-sent with the whole product
    // section on every option click and most variants share a set. The plain
    // {variantId: row} shape is still accepted so a page cached from before the
    // change keeps working.
    var sets = data.sets || data;
    var key = (data.map && data.map[vid]) || vid;
    var row = sets[key];
    if (!row) return;

    // The screen protector is sold per phone model, so the accessory variant
    // must follow the case's Size. 23 of the 55 case models (all Samsungs and
    // the older iPhones) have no protector at all -- for those the kit tier is
    // hidden rather than shipping a mismatched size.
    var kitInput = box.querySelector('input[data-offer-mode="kit"]');
    if (kitInput) {
      var kitRow = kitInput.closest('[data-offer-row]');
      if (row.addonId) {
        kitInput.setAttribute('data-offer-addon', row.addonId);
        if (kitRow) kitRow.hidden = false;
        // the accessory itself can change per model (protector -> tether)
        var title = box.querySelector('[data-offer-addon-title]');
        if (title && row.addonTitle) title.textContent = row.addonTitle;
        var note = box.querySelector('[data-offer-addon-note]');
        if (note) note.textContent = row.addonSize ? ' (' + row.addonSize + ')' : '';
        // ...and so does its photo (server-rendered for the first variant only)
        var aimg = box.querySelector('[data-offer-addon-img]');
        if (aimg && row.addonImg && aimg.getAttribute('src') !== row.addonImg) aimg.setAttribute('src', row.addonImg);
      } else {
        if (kitInput.checked) {
          var single = box.querySelector('input[data-offer-mode="single"]');
          if (single) { single.checked = true; }
        }
        if (kitRow) kitRow.hidden = true;
      }
    }
    // NOTE: money_format on this shop is HTML (a currency app wraps amounts in
    // <span class="langwill-money"><span class=money>), so these must be written
    // as HTML -- textContent would print the markup as literal text, and
    // stripping it would break the app's currency conversion. The values come
    // from Liquid's `money` filter, not from user input.
    Object.keys(row).forEach(function (k) {
      box.querySelectorAll('[data-offer-price="' + k + '"]').forEach(function (n) {
        if (n.innerHTML !== row[k]) n.innerHTML = row[k];
      });
    });
  }

  var burstTimers = [];
  function burstSync() {
    burstTimers.forEach(clearTimeout);
    burstTimers = [0, 80, 200, 400, 800, 1500].map(function (d) {
      return setTimeout(function () { syncOfferPrices(); }, d);
    });
  }

  document.addEventListener('change', burstSync);
  document.addEventListener('input', burstSync);
  document.addEventListener('click', burstSync);
  document.addEventListener('cart:refresh', burstSync);

  function watchVariantInput() {
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    if (!idInput || idInput.getAttribute('data-scb-watched')) return;
    idInput.setAttribute('data-scb-watched', '1');
    try {
      new MutationObserver(function () { syncOfferPrices(); })
        .observe(idInput, {attributes: true, attributeFilter: ['value']});
    } catch (err) {}
  }

  setInterval(function () { watchVariantInput(); syncOfferPrices(); }, 500);

  if (document.readyState !== 'loading') { watchVariantInput(); syncOfferPrices(true); }
  else document.addEventListener('DOMContentLoaded', function () {
    watchVariantInput(); syncOfferPrices(true);
  });

  // "Add both" kit button — adds the CURRENTLY SELECTED case (variant, quantity
  // and MYOC line-item properties all preserved via caseLineItem) together with
  // the accessory in a single /cart/add call, so the drawer opens once.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-bundle-add]') : null;
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled) return;

    var addonId = btn.getAttribute('data-bundle-add');
    var idInput = document.querySelector('form[action*="/cart/add"] input[name="id"]');
    var form = idInput ? idInput.form : null;

    var items = [];
    if (form) {
      var ci = caseLineItem(form);
      if (ci && ci.id) items.push(ci);
    }
    if (addonId) items.push({id: addonId, quantity: 1});
    if (!items.length) return;

    var label = btn.querySelector('[data-bundle-label]');
    var original = label ? label.innerHTML : null;
    btn.disabled = true;

    addToCart(items)
      .then(function () {
        btn.classList.add('is-added');
        if (label) label.textContent = '✓ Added';
        setTimeout(function () {
          btn.classList.remove('is-added');
          if (label && original !== null) label.innerHTML = original;
          btn.disabled = false;
        }, 1800);
      })
      .catch(function () {
        if (label && original !== null) label.innerHTML = original;
        btn.disabled = false;
      });
  });

  // The 2-pack card is an informational nudge only (no button). Its progress
  // bar / status is rendered by Liquid on load and kept live by syncTwopack
  // below as cases are added elsewhere (main ATC, drawer). The main product
  // "Add To Cart" handles adding the case; the cart drawer pushes the 2nd.

  // Payment-methods popup: open/close the modal.
  function closePayModals() {
    document.querySelectorAll('[data-paymethods-modal]').forEach(function (m) { m.hidden = true; });
    document.body.style.overflow = '';
  }
  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    if (e.target.closest('[data-paymethods-open]')) {
      e.preventDefault();
      var modal = document.querySelector('[data-paymethods-modal]');
      if (modal) { modal.hidden = false; document.body.style.overflow = 'hidden'; }
      return;
    }
    if (e.target.closest('[data-paymethods-close]')) {
      e.preventDefault();
      closePayModals();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && document.querySelector('[data-paymethods-modal]:not([hidden])')) {
      closePayModals();
    }
  });

  // Cycle the perks-bar message through msgs (fade every 3.5s). Timer is stored
  // on the element so re-syncs / drawer re-renders don't stack timers.
  function rotatePerksMessage(bar, msgs) {
    var el = bar.querySelector('[data-perks-message]');
    if (!el) return;
    if (bar.__perksTimer) { clearInterval(bar.__perksTimer); bar.__perksTimer = null; }
    el.style.opacity = '1';
    el.textContent = msgs[0];
    if (msgs.length < 2) return;
    var i = 0;
    bar.__perksTimer = setInterval(function () {
      if (!document.body.contains(bar)) { clearInterval(bar.__perksTimer); return; }
      i = (i + 1) % msgs.length;
      el.style.opacity = '0';
      setTimeout(function () { el.textContent = msgs[i]; el.style.opacity = '1'; }, 300);
    }, 3500);
  }

  // Keep the 2-pack button AND the two-tier perks bar in sync with the cart.
  function syncTwopack() {
    if (!document.querySelector('[data-twopack]') && !document.querySelector('[data-perks-bar]')) return;
    // A "case" is what the case 2-pack discount counts: the "All Cases"
    // collection's own rules (title without tether / screen / bracelet, type
    // not zakeke-design), mirrored for /cart.js, which has no collections;
    // snippets/free-shipping-bar.liquid checks the collection itself. The free
    // CreedLink parts (product type "Free gift") are neither cases nor items.
    function isCase(it) {
      var title = String(it.product_title || '').toLowerCase();
      var type = String(it.product_type || '').toLowerCase();
      return !/tether|screen|bracelet/.test(title) && type.indexOf('zakeke-design') === -1 && type !== 'free gift';
    }
    fetch(cartRoot() + 'cart.js', {headers: {'Accept': 'application/json'}})
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var caseQty = 0, giftQty = 0;
        (cart.items || []).forEach(function (it) {
          if (String(it.product_type || '').toLowerCase() === 'free gift') giftQty += it.quantity;
          else if (isCase(it)) caseQty += it.quantity;
        });

        // Two-tier perks bar (mid = free shipping @ 2 items, end = discount @ 2
        // cases). The MESSAGE shows one step at a time.
        //
        // The copy is NOT in this file. snippets/free-shipping-bar.liquid
        // renders the five messages, translated (locales/*.json,
        // skiingcreed.perks_bar) and with the amount filled in, into
        // data-perks-msg-* attributes; this reads them back. A hardcoded
        // English table here is how a German cart showed "Add 1 more item for
        // free shipping" after the first add (Propeel #453276198, 2 Sept
        // 2026). The English below is only a fallback for a missing attribute.
        document.querySelectorAll('[data-perks-bar]').forEach(function (bar) {
          var save = bar.getAttribute('data-perks-save') || '$12';
          function t(key, fallback) {
            return bar.getAttribute('data-perks-msg-' + key) || fallback;
          }
          var n = cart.item_count - giftQty, pct, msg;
          if (caseQty >= 2) {
            pct = 100;
            msg = t('unlocked', 'Free shipping + ' + save + ' off unlocked ✓');
          } else if (n >= 2) {
            pct = caseQty === 1 ? 75 : 60;
            msg = caseQty === 1
              ? t('add-one-case', 'Add 1 more case to save ' + save)
              : t('add-two-cases', 'Add 2 cases to save ' + save);
          } else if (n === 1) {
            pct = 25;
            msg = t('add-one-item', 'Add 1 more item for free shipping');
          } else {
            pct = 0;
            msg = t('add-two-items', 'Add 2 items for free shipping');
          }
          var fill = bar.querySelector('[data-perks-fill]');
          if (fill) fill.style.width = pct + '%';
          rotatePerksMessage(bar, [msg]);
          var mid = bar.querySelector('[data-perks-mid]');
          if (mid) mid.classList.toggle('is-done', n >= 2 || caseQty >= 2);
          var end = bar.querySelector('[data-perks-end]');
          if (end) end.classList.toggle('is-done', caseQty >= 2);
        });

        document.querySelectorAll('[data-twopack]').forEach(function (card) {
          var save2 = card.getAttribute('data-2pack-save') || '€12';
          card.classList.toggle('is-complete', caseQty >= 2);
          var fill = card.querySelector('[data-2pack-fill]');
          if (fill) fill.style.width = Math.min(100, caseQty * 50) + '%';
          var status = card.querySelector('[data-2pack-status]');
          if (status) {
            if (caseQty >= 2) status.textContent = '✓ You saved ' + save2 + '!';
            else if (caseQty === 1) status.textContent = '1 of 2 — add 1 more to save ' + save2 + '!';
            else status.textContent = 'Add 2 cases to unlock ' + save2 + ' off';
          }
        });
      })
      .catch(function () {});
  }

  // Keep the 2-pack button in sync with EVERY cart change (add, remove, qty)
  // by observing cart-mutating fetches the theme makes.
  if (window.fetch && !window.__twopackFetchPatched) {
    window.__twopackFetchPatched = true;
    var origFetch = window.fetch;
    window.fetch = function (input) {
      var u = (typeof input === 'string') ? input : (input && input.url) || '';
      var pr = origFetch.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)/.test(u)) {
        // twice: once fast, once after the theme's own drawer re-render
        // (which replaces the perks-bar HTML and would undo the first sync)
        pr.then(function () { setTimeout(syncTwopack, 300); setTimeout(syncTwopack, 1300); }).catch(function () {});
      }
      return pr;
    };
  }
  document.addEventListener('cart:refresh', syncTwopack);
  // the drawer body is stamped from a <template> on first open — sync right
  // after so the perks bar reflects the current cart, not the page-load cart
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-sidebar-id="CartDrawer"]')) {
      setTimeout(syncTwopack, 450);
    }
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncTwopack);
  } else {
    syncTwopack();
  }
})();

/* Bracelet cards ("Complete your setup" and the cart drawer's "Usually Bought
   Together"): a thumbnail tap switches photo, title, links, price and the
   + Add variant. Delegated on document so it survives the theme's block
   re-renders and the drawer's innerHTML refresh after an add. */
(function () {
  if (window.__fbtPickBound) return;
  window.__fbtPickBound = true;
  document.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target.closest('[data-fbt-pick-thumb]') : null;
    if (!t) return;
    e.preventDefault();
    var card = t.closest('[data-fbt-pick]');
    if (!card) return;
    var thumbs = card.querySelectorAll('[data-fbt-pick-thumb]');
    for (var i = 0; i < thumbs.length; i++) {
      var on = thumbs[i] === t;
      thumbs[i].classList.toggle('is-active', on);
      thumbs[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var img = card.querySelector('[data-fbt-pick-img]');
    if (img) { img.src = t.getAttribute('data-img'); img.srcset = t.getAttribute('data-srcset'); }
    var links = card.querySelectorAll('[data-fbt-pick-link]');
    for (var j = 0; j < links.length; j++) links[j].href = t.getAttribute('data-url');
    var title = card.querySelector('[data-fbt-pick-title]');
    if (title) title.textContent = t.getAttribute('data-title');
    var price = card.querySelector('[data-fbt-pick-price]');
    if (price) price.innerHTML = t.getAttribute('data-price');
    var add = card.querySelector('[data-fbt-pick-add]');
    if (add) {
      add.setAttribute('value', t.getAttribute('data-variant'));
      add.setAttribute('aria-label', 'Add ' + t.getAttribute('data-title'));
    }
  });
})();

/* Sized add-on on the CreedLink card (size_pick in product-fbt-bundle.liquid):
   an invisible phone <select> lies over + Add, so a tap opens the phone list
   (the iOS wheel) and the chosen size is the variant that gets added, through
   the + Add handler above. The list resets afterwards, ready for another. */
(function () {
  if (window.__fbtSizeBound) return;
  window.__fbtSizeBound = true;
  document.addEventListener('change', function (e) {
    var sel = e.target && e.target.closest ? e.target.closest('[data-fbt-size]') : null;
    if (!sel || !sel.value) return;
    var btn = sel.parentNode.querySelector('[data-fbt-add-item]');
    if (!btn) return;
    btn.setAttribute('value', sel.value);
    btn.click();
    sel.selectedIndex = 0;
  });
})();

/* Pair offer (snippets/pair-offer.liquid) on the CreedLink add-on row and on
   the cart drawer's Usually Bought Together card: [1x] [2x price each]. The
   choice sets how many the add sends (button data-fbt-qty, or the card
   form's input[data-pair-qty]) and swaps the price for the pair total with
   "You save". With 2 the cart's automatic discount "CreedLink 2+" applies.
   Delegated, so re-rendered blocks and drawer refreshes keep working. */
(function () {
  if (window.__fbtPairBound) return;
  window.__fbtPairBound = true;
  document.addEventListener('click', function (e) {
    var opt = e.target.closest ? e.target.closest('[data-fbt-pair]') : null;
    if (!opt) return;
    e.preventDefault();
    var scope = opt.closest('[data-pair-scope]');
    if (!scope) return;
    var qty = opt.getAttribute('data-fbt-pair');
    var opts = scope.querySelectorAll('[data-fbt-pair]');
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i] === opt;
      opts[i].classList.toggle('is-on', on);
      opts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
    }
    var btn = scope.querySelector('[data-fbt-add-item]');
    if (btn) btn.setAttribute('data-fbt-qty', qty);
    var input = scope.querySelector('input[data-pair-qty]');
    if (input) input.value = qty;
    var price = scope.querySelector('[data-pair-price]');
    var tpl = scope.querySelector('template[data-pair-html]');
    if (price && tpl) {
      if (!price.hasAttribute('data-pair-orig')) price.setAttribute('data-pair-orig', price.innerHTML);
      price.innerHTML = qty === '2' ? tpl.innerHTML : price.getAttribute('data-pair-orig');
    }
  });
})();
